import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of, throwError } from "rxjs";
import { catchError, tap } from 'rxjs/operators';
import { ScalarResponseModel } from "../../models/scalar/scalar.model";
import { UserPasswordModel, UserPersonModel, UserRoleModel, UserRoleNameModel, UserSearchModel } from "src/app/models/user/user.model";

@Injectable({
    providedIn: 'root'
})

export class UserService {

    private UPDATE_USER_THEME_URL = 'api/user/updateUserTheme/{userId}/{value}'
    private USERS_BY_DISTID_URL = 'api/user/getUsersByDistId/'
    private USER_BY_ID_URL = 'api/user/getById/'
    private USER_ROLES_URL = 'api/user/getRoles/'
    private USER_ROLE_LIST_URL = 'api/user/getUserRoleList/'
    private USER_SAVE_URL = 'api/user/saveUser'
    private USER_SAVE_PASSWORD_URL = 'api/user/saveUserPassword'
    private USER_TEST = 'api/user/saveUserTest'
    private USERS_LOOKUP = 'api/user/usersLookup/'

    constructor(
        private _httpClient: HttpClient
    ) {
    }

    get url(): string {

        return this.UPDATE_USER_THEME_URL;
    }

    updateUserTheme$(userId: string, value: string): Observable<ScalarResponseModel> {
        let x = this.url.replace('{userId}', userId);
        let y = x.replace('{value}', value);
        return this._httpClient.get<ScalarResponseModel>(`${y}`);
    }

    getUsersByDistId$(id: number): Observable<UserPersonModel[]> {
        return this._httpClient.get<UserPersonModel[]>(`${this.USERS_BY_DISTID_URL}${id}`);
    }

    usersLookup$(searchText: string, id: number): Observable<UserSearchModel[]> {
        return this._httpClient.get<UserSearchModel[]>(`${this.USERS_LOOKUP}${searchText}/${id}`);
    } 

    getUserById$(id: number): Observable<UserPersonModel> {
        return this._httpClient.get<UserPersonModel>(`${this.USER_BY_ID_URL}${id}`);
    }

    getNewUser(distributorId: number): Observable<UserPersonModel> {
        return this._httpClient.get<UserPersonModel>(`/api/user/new/${distributorId}`);
    }

    getUserRoles$(distOnly: boolean): Observable<UserRoleModel[]> {
        return this._httpClient.get<UserRoleModel[]>(`${this.USER_ROLES_URL}${distOnly}`);
    }

    getUserRoleList$(id: number): Observable<UserRoleNameModel[]> {
        return this._httpClient.get<UserRoleNameModel[]>(`${this.USER_ROLE_LIST_URL}${id}`);
    }

    saveUser$(userPersonModel: UserPersonModel): Observable<UserPersonModel | null> {
        return this._httpClient.post<UserPersonModel>(this.USER_SAVE_URL, { UserPersonResponseModel: userPersonModel }).pipe(
            tap(response => {

            }),
            catchError(error => {
                return of(error.error || 'Unknown error');
            }),
        );
    }

    saveUserPassword$(userPasswordModel: UserPasswordModel): Observable<UserPasswordModel | null> {
        return this._httpClient.post<UserPasswordModel>(this.USER_SAVE_PASSWORD_URL, { UserPasswordResponseModel: userPasswordModel }).pipe(
            tap(response => {

            }),
            catchError(error => {
                return of(error.error || 'Unknown error');
            }),
        );
    }

    saveUserTest$(userPersonModel: UserPersonModel): Observable<UserPersonModel | null> {
        return this._httpClient.post<UserPersonModel>(this.USER_TEST, { UserPersonResponseModel: userPersonModel }).pipe(
            tap(response => {

            }),
            catchError(error => {
                console.log(error);
                return of(null);
            }),
        );
    }


}
